(function () {
  function sync(section) {
    var row = section.querySelector('.th-resource__row');
    var track = section.querySelector('.th-resource__progress');
    var bar = section.querySelector('.th-resource__progress-bar');
    if (!row || !track || !bar) return;

    var overflow = row.scrollWidth - row.clientWidth;
    if (overflow <= 1) {
      track.hidden = true;
      return;
    }

    track.hidden = false;
    var visible = row.clientWidth / row.scrollWidth;
    var progress = row.scrollLeft / overflow;
    bar.style.width = visible * 100 + '%';
    bar.style.marginInlineStart = progress * (1 - visible) * 100 + '%';
  }

  function init(section) {
    var row = section.querySelector('.th-resource__row');
    if (!row) return;
    sync(section);
    row.addEventListener('scroll', function () {
      sync(section);
    }, { passive: true });
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(function () {
        sync(section);
      }).observe(row);
    }
  }

  function boot() {
    document.querySelectorAll('.th-resource').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.th-resource');
    if (section) init(section);
  });
})();
